import PropTypes from 'prop-types';

const tagShape = PropTypes.shape({
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export default tagShape;
